export default "__VITE_ASSET__BALnnEfg__"